/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
import { GetterTree } from 'vuex';
import * as types from '@/store/types';
import { RootState } from '../models';
import { API, APIState } from './models';

export const getters: GetterTree<APIState, RootState> = {
  [types.GET_LOADING]({ loading }): boolean {
    return loading;
  },

  [types.GET_APIS]({ apis }): API[] {
    return apis;
  },
};
